module.exports = __webpack_public_path__ + "img/gj_9.be38ac61.jpg";